module.exports = "https://web-assets.ifttt.com/packs/media/stencils/spreadsheet-344dc4d9.svg";